import { Component, Input, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { Icons } from '../../../util/Icons';
import { LayoutService } from '../../../../@vex/services/layout.service';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'ara-spinner-button',
	templateUrl: './ara-spinner-button.component.html',
	styleUrls: ['./ara-spinner-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatButton, MatTooltip, MatIcon, MatProgressSpinner],
})
export class AraSpinnerButtonComponent {
	protected layoutService = inject(LayoutService);
	protected icons = inject(Icons);

	readonly showSpinner = input(false);
	readonly disabledWhenSpinning = input(true);
	@Input() svgIcon: string;
	@Input() matIcon: string;
	readonly buttonText = input<string>(undefined);
	readonly buttonName = input<string>(undefined);
	readonly hideTextOnMobile = input(true);
	readonly toolTip = input('');
	readonly disabledByReason = input<boolean>(false);
	readonly action = input<() => void>(undefined); // Function passed as a parameter
	readonly type = input('button');

	onButtonClick(): void {
		const action = this.action();
		if (action) {
			action(); // Execute the passed function
		}
	}
}
